import { render } from "./PopUpCliente.vue?vue&type=template&id=533cc8b8&scoped=true"
import script from "./PopUpCliente.vue?vue&type=script&lang=js"
export * from "./PopUpCliente.vue?vue&type=script&lang=js"

import "./PopUpCliente.vue?vue&type=style&index=0&id=533cc8b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\germa\\dev\\es.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533cc8b8"]])

export default __exports__